import { OndemandVideo } from "./ondemand_video";

const iconsList = [
  { label: "OndemandVideo", code: <OndemandVideo /> },
];

export {
  iconsList,
  OndemandVideo,
};
